/**
 * Clients API Service
 * Handles client configuration operations.
 *
 * Base URL: /api (apiFetch adds /api prefix)
 */
import { useCallback, useMemo } from "react";
import { useApi } from "@/hooks/use-api";

const CLIENTS_BASE = "/clients";

interface ClientBridgeNameResponseDto {
    bridgeName: string | null;
    /** Client export mode ("DirectSync" | "Csv"). Absent on older backends → treat as DirectSync. */
    exportMode?: string;
}

/**
 * Hook providing client API operations with authentication
 */
export function useClientsApi() {
    const api = useApi();

    /**
     * Get the bridge name for the authenticated user's client
     * GET /clients/bridge-name
     */
    const getClientBridgeName = useCallback(async (): Promise<ClientBridgeNameResponseDto> => {
        return api.get<ClientBridgeNameResponseDto>(`${CLIENTS_BASE}/bridge-name`);
    }, [api]);

    return useMemo(
        () => ({
            getClientBridgeName,
        }),
        [getClientBridgeName],
    );
}
